import { Input } from "@/components/ui/input";

interface InputProps {
  type: string;
  placeholder: string;
  onChange?: () => void;
  defaultValue?: string;
  icon?: React.ReactNode;
  min?: string;
}

const MyInput: React.FC<InputProps> = (props) => {
  const { type, placeholder, onChange, defaultValue, icon, min } = props;
  return (
    <div className="relative mt-2">
      <span className="w-4 h-4 absolute top-3 start-4">{icon}</span>
      <Input
        className="ps-11 w-full py-2 px-3 h-10 justify-end bg-transparent rounded outline-none border border-gray-200 focus:border-indigo-600 focus:ring-0"
        type={type}
        min={min}
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default MyInput;
